export const HOTELS_UPSTREAM_BASE_URL = ''

export const ADULT_TITLES = ['Mr', 'Ms', 'Mrs'] as const

export const MAX_GUEST_NAME_LENGTH = 60

export const MAX_SPECIAL_REQUEST_LENGTH = 250

export const HOTEL_EMI_INSTALLMENTS = 4

export const DEFAULT_HOTEL_DIAL_CODE = '966'

export const HOTEL_REVIEW_ERROR = 'HOTEL_REVIEW_ERROR'

export const HOTEL_SEARCH_ERROR = 'HOTEL_SEARCH_ERROR'

export const HOTEL_LAST_SEARCH_STORAGE_KEY = 'hotelLastSearch'

export const HOTEL_CONFIRMATION_TIMEOUT_MS = 20000

export const REVIEW_DEFAULT_VISIBLE_OPTIONS = 3

export const HOTEL_MAX_NIGHTS = 28

export const HOTEL_API_LANGUAGE = 'en'

/** Neutral fallback shown when a hotel/room image fails to load. */
// CDN-hosted so the artwork can be swapped without a deploy. Same file as
// public/assets/hotels/placeholder.svg, which is kept as the source of the artwork.
export const HOTEL_IMAGE_PLACEHOLDER = 'https://ui.cltp.co/offers-ui/OfferPages/offers/cms/placeholder.svg'

export const ROOM_CAROUSEL_MAX_VISIBLE = 5

export const ROOM_AMENITIES_PREVIEW_COUNT = 4

export const SRP_STAR_BUCKETS = [5, 4, 3, 2, 1, 0] as const

export const SRP_GUEST_RATING_THRESHOLDS = [9, 8, 7, 6] as const

export const HOTEL_AUTO_SUGGEST_PATH = '/prefixy/ui/autoSuggest/getSuggestions'

export const HOTEL_ITINERARY_BASE_PATH = '/hotel/orchestrator/v2/itinerary'

export const HOTEL_ITINERARY_CREATE_PATH = `${HOTEL_ITINERARY_BASE_PATH}/create`

const ITINERARY_DOMAIN_COUNTRY: Record<string, string> = {
    FSA: 'SA',
    FEG: 'EG',
    FAE: 'AE'
}

export const toItineraryDomainCountry = (code: string): string => ITINERARY_DOMAIN_COUNTRY[code] ?? code

export const HOTEL_AUTO_SUGGEST_USE_CASE = 'HOTEL_HOME_PAGE'

export const HOTEL_AUTO_SUGGEST_MIN_CHARS = 2

export const HOTEL_AUTO_SUGGEST_DEBOUNCE_MS = 300

export const HOTEL_SEARCH_ID_TYPE = 'ct'
